import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';

  
const bankPoiStyle =
  new Style({
    image: new Icon({
      anchor: [0.5, 46],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: 'data/icons/24px/bank.png',
      color: '#0F9D58',
      scale: 0.7
    }),
  });

  export const poiBankLayer = new VectorLayer({
  source: new VectorSource({
    url: 'data/india/UP/point_of_interest_MNYFIN.json',
    // url: 'data/india/Gujarat/point_of_interest_part_jamnagar.json',
    format: new TopoJSON({
      //layers: ['MNYFIN'],
      layers: ['MNYFIN'],
    }),
    overlaps: true,
  }),
  //minZoom: POI_MIN_ZOOM_LEVEL,
  style: bankPoiStyle,
  visible: true,
  zIndex: 2
  });